import { MultiCollapsible } from "@bonliva-crm/ui";
import {
  ProfessionFilterModalInnerProps,
  encodeValue,
  toDecodedLabelValue,
  getProfessionToValue,
  renderSelectType,
  Option
} from "../../utils";
import { ComponentProps, useMemo, useState } from "react";
import { useGlobalStore } from "@hooks";
import locale from "@bonliva-crm/locale";
import { SelectType } from "@bonliva-crm/shared";
import { ExperienceAndJobofferFilter } from "./common/experience-and-joboffer-filter";
import {
  baseOnChange,
  commonCollapsibleProps,
  isCollapsed,
  isGroupSelected,
  filterOption,
  isOptionStandAlone,
  onCollapse
} from "./utils";
import { isFilterSelected } from "../../../../utils/is-filter-selected";
import { sortBy } from "lodash";

export const DoctorFilter = (props: ProfessionFilterModalInnerProps) => {
  const store = useGlobalStore();
  const [collapsedGroups, setCollapsedGroups] = useState<string[]>([]);

  const professionKey = getProfessionToValue(props.value.professions[0]);
  const professionObject = props.value[professionKey];

  const areaOfExpertise = useMemo(() => {
    const aoe = store.cache.getAreaOfExpOnProfessions(props.value.professions);

    return sortBy(aoe, (x) => x.Name);
  }, [professionKey]);

  if (!("experience" in professionObject)) {
    return null;
  }

  const value = professionObject.experience.value;
  const type = professionObject.experience.type;

  const options: Option[] = [];

  areaOfExpertise.forEach((aoe) => {
    const specializationsToOptions = aoe.Specializations.map((spec) => ({
      label: spec,
      value: encodeValue(aoe.Name, spec)
    }));

    options.push({
      label: aoe.Name,
      value: aoe.Name
    });

    sortBy(specializationsToOptions, "label").forEach((spec) => options.push(spec));
  });

  const onChange = baseOnChange(options, (finalValues) => {
    props.onChange({
      ...props?.value,
      [professionKey]: {
        experience: {
          value: finalValues.map((x) => x.value),
          type: type
        }
      },
      experience: !!finalValues?.length,
      interested: finalValues.length > 0 && professionKey === "doctor" ? "true" : "null",
      experienced: finalValues.length > 0 && professionKey === "doctor" ? "true" : "null"
    });
  });

  const multiSelectProps: ComponentProps<typeof MultiCollapsible<Option>> = {
    ...commonCollapsibleProps,
    inputLabel: locale.Specialization,
    placeholder: null,
    options,
    value: toDecodedLabelValue(value),
    onChange,
    isOptionSelected: isGroupSelected(value, options, true),
    isIndeterminate: isGroupSelected(value, options, false),
    filterOption: filterOption(collapsedGroups, false, options),
    isCollapsed: isCollapsed(collapsedGroups),
    isOptionStandAlone: isOptionStandAlone(options),
    onCollapse: onCollapse(collapsedGroups, setCollapsedGroups),
    showBadge: isFilterSelected(professionObject.experience),
    isClearable: isFilterSelected(professionObject.experience),
    onClear: () => {
      props.onChange({
        ...props?.value,
        [professionKey]: {
          experience: {
            type: SelectType.ANY,
            value: []
          }
        },
        experienced: null,
        interested: null
      });
    },
    menuChildren: {
      prependedChildren: renderSelectType(type, (t: SelectType) => {
        props.onChange({
          ...props?.value,
          [getProfessionToValue(props?.value?.professions?.[0])]: {
            experience: {
              value: value,
              type: t
            }
          }
        });
      })
    }
  };

  return (
    <>
      <MultiCollapsible<Option> {...multiSelectProps} />
      {value.length > 0 && <ExperienceAndJobofferFilter {...props} />}
    </>
  );
};
